<template>
  <common-template-saas-structure>
    <div class="page-satd">

      <layout-nav-tab-menu
        v-if="!hideTabMenu"
        v-model="selectedTabMenu"
        class="page-satd__nav"
        :items="tabMenuItems"
        @update:model-value="onRouteChangeIntent"
      />

      <div class="page-satd__main">
        <nuxt-page />
      </div>

    </div>
  </common-template-saas-structure>
</template>

<style lang="sass" scoped>
.page-satd
  $self: &

  display: flex
  flex-grow: 1
  flex-direction: column

  &__nav
    padding-top: space-x(2)
    flex-shrink: 0

  &__main
    display: flex
    flex-grow: 1
    flex-direction: column

</style>

<script lang="ts">
import { useCompanyRequiredNavigationGuard } from '~/composables/layout/navigation'
import { any, includes, not, propOr, test } from '~/utils/lib/core/prelude'
import type { LayoutNavTabMenuPropsItem } from '~/components/layout/nav/TabMenu.vue'
import { mapWritableState } from 'pinia'
import { getAccomptesRoute, getSaisiesRoute, TAB_MENU, useStore_satd } from '~/stores/satd'
import { extractRouteCompanyCode } from '~/stores/layout/navigation'
import { MENU_ITEM, NAVIGATION_SCOPE } from '~/utils/lib/layout/types'

export default defineNuxtComponent({
  setup() {
    definePageMeta({
      navigationScope: NAVIGATION_SCOPE.COMPANY_REQUIRED,
      menuItem: MENU_ITEM.SATD,
      middleware: [
        'session-control-gate',
        'company-required-gate',
        function (to) {
          const needDefaultRedirection = test(
            /satd$/,
            to.path
          )

          if (not(needDefaultRedirection))
            return

          const structure_id :string = propOr('', 'dataId', to.params)
          const companyCode :string = extractRouteCompanyCode(to)

          const defaultRoute = getSaisiesRoute(structure_id, companyCode)

          return navigateTo(defaultRoute, { replace: true })
        }
      ],
    })
    const navigationContext = useCompanyRequiredNavigationGuard()

    useHead({
      title: `Saisies`,
    })

    return {
      ...navigationContext,
    }
  },
  data() {
    return {
      TAB_MENU,
      tabMenuItems: [] as LayoutNavTabMenuPropsItem[],
    }
  },
  computed: {
    ...mapWritableState(useStore_satd, [
      'selectedTabMenu',
    ]),
    hideTabMenu() {
      const HIDE_TAB_MENU_PATHS = [
        '/details',
        '/add',
      ]
      return any(
        (path) => includes(path, this.$router.currentRoute.value.path),
        HIDE_TAB_MENU_PATHS
      )
    }
  },
  created() {
    this.setTabItems()
  },
  methods: {
    onRouteChangeIntent(tab_item) {
      const {
        structure: { id },
        company: { code_societe },
      } = this.fromCompanyLevel()

      const route = (() => {
        switch (tab_item as TAB_MENU) {
          case TAB_MENU.ACCOMPTES:
            return getAccomptesRoute(id, code_societe)
          case TAB_MENU.SAISIES:
            return getSaisiesRoute(id, code_societe)
        }
      })()

      return navigateTo(route, { replace: true })
    },
    /**
     * @desc
     *    optional argument in order to set view-model data on first print
     *    (ie. not knowing tab item badge count value)
     */
    setTabItems() {
      this.tabMenuItems = [
        {
          id: TAB_MENU.ACCOMPTES,
          text: `Liste des acomptes`,
          status: this.UI.STATUS.DISABLED,
        },
        {
          id: TAB_MENU.SAISIES,
          text: `Liste des saisies`,
        },
      ]
    },
  }
})
</script>
